import { useMemo } from 'react';

import { Field, Widget } from '@kanda-libs/ks-component-ts';
import { Text } from '@kanda-libs/ks-design-library';

import { MONTHLY_INCOME_VALIDATION, NOT_EMPLOYED_PROPS } from './constants';

import { ERROR_PROPS } from '../../PrimaryEmployment/constants';
import useEmploymentStatusFields from '../../PrimaryEmployment/useEmploymentStatusFields';
import { MONTHS_OPTIONS } from '../EmploymentMonths/constants';

export interface RetiredSecondaryProps {
  index: number;
  arrayName: string;
}

const RetiredSecondary: React.FunctionComponent<RetiredSecondaryProps> =
  function ({ index, arrayName }) {
    const { error, validation, yearsName, monthsName, yearsOptions } =
      useEmploymentStatusFields({
        type: 'secondary',
        employmentType: 'retired',
        index,
        arrayName,
      });
    const baseName = useMemo(
      () => `${arrayName}.${index}.retired_details`,
      [arrayName, index],
    );
    const monthlyTakeHomeName = useMemo(
      () => `${baseName}.monthly_income_after_tax`,
      [baseName],
    );
    return (
      <div className="grid grid-cols-2 gap-x-3 md:gap-x-4">
        <Field.Validator validation={MONTHLY_INCOME_VALIDATION}>
          <Field.NumberInput
            {...NOT_EMPLOYED_PROPS.monthlyIncome}
            className="col-span-2"
            name={monthlyTakeHomeName}
          />
        </Field.Validator>
        <span className="col-span-2 text-12-18-em text-neutral-700 w-full mb-2">
          When did you retire?
        </span>
        <Field.Select
          options={MONTHS_OPTIONS}
          name={monthsName}
          placeholder="Month"
        />
        <Field.Select
          options={yearsOptions}
          name={yearsName}
          placeholder="Year"
        />
        {error && <Text text={error} className={ERROR_PROPS.className} />}
        <div className="hidden">
          <Widget.CreditAdditionalEmploymentDetailsRetiredDetailsMonthsRetiredArrayInput
            validation={validation}
            name="retired_details.months_retired"
          />
        </div>
      </div>
    );
  };

export default RetiredSecondary;
